import { gql } from '@apollo/client'

const CHART_DATA_FIELDS = `
  rows {
    keys
    value
  }
  labels {
    id
    label
  }
  total
  computedAt
  status
`

// A saved chart's numbers: the viewer's snapshot, REFRESHING while the server recomputes it
export const CHART_DATA_QUERY = gql`
  query CHART_DATA_QUERY($chartId: ID!) {
    chartData(chartId: $chartId) {
      ${CHART_DATA_FIELDS}
    }
  }
`

// An unsaved query's numbers, computed live: the editor preview
export const CHART_PREVIEW_QUERY = gql`
  query CHART_PREVIEW_QUERY($input: ChartDataInput!) {
    chartPreview(input: $input) {
      ${CHART_DATA_FIELDS}
    }
  }
`

export const CHART_FIELDS = `
  id
  title
  description
  query {
    riskTemplateId
    groupBy {
      fieldId
      dateBucket
    }
    aggregate
    aggregateFieldId
    filterId
  }
  config
`

export const CHART_QUERY = gql`
  query CHART_QUERY($id: ID!) {
    chart(id: $id) {
      ${CHART_FIELDS}
    }
  }
`

export const CHART_TEMPLATE_FIELDS_QUERY = gql`
  query CHART_TEMPLATE_FIELDS_QUERY($filter: RiskTemplateFilterInput) {
    riskTemplates(filter: $filter) {
      data {
        id
        name
        fields {
          id
          label
          fieldType
          active
          multiple
          settings
          options {
            id
            label
            value
          }
        }
      }
    }
  }
`
